module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "i": "first-in-shop"
    }
  }, [_c('yd-popup', {
    attrs: {
      "position": "center",
      "close-on-masker": false
    },
    model: {
      value: (_vm.firstDialog),
      callback: function($$v) {
        _vm.firstDialog = $$v
      },
      expression: "firstDialog"
    }
  }, [_c('img', {
    staticClass: "vip-gift-img",
    attrs: {
      "src": "/static/image/first_in_shop.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "vip-gift-desc"
  }, [_vm._v("我们为您挑选了一些优惠热卖的礼包商品，购买礼包商品后可成为店铺会员，享受永久店铺购买特权以及相关会员权益。")]), _vm._v(" "), _c('footer', {
    staticClass: "first-dialog-footer"
  }, [_c('button', {
    on: {
      "click": _vm.hiddenDialog
    }
  }, [_vm._v("跳过")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.goVipGift
    }
  }, [_vm._v("去看看")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-72a6980e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/First_in_shop.vue
// module id = 1500
// module chunks = 131